import React from "react";
import QuizHome from "./QuizHome";

const OwnerTriviasSection = () => <QuizHome forcePlayable />;

export default OwnerTriviasSection;
